import script from "./CheckboxFilter.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckboxFilter.vue?vue&type=script&setup=true&lang=ts"

import "./CheckboxFilter.vue?vue&type=style&index=0&id=b1a2aa2e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1a2aa2e"]])

export default __exports__